import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { DBDropDown, DBIntField, DBTextField } from '_components';
import styles from './Social.module.css';
import { PatientCareCenterNoteNavAnchor } from '../NavAnchor';


class PatientCareCenterNoteSubjectiveSocial extends React.Component {

    render() {
        return (
            <PatientCareCenterNoteNavAnchor id='subj_social'>
                <div>

                    <div className={styles.row}>
                        <label className={styles.col1_req}>Patient lives with:</label>
                        <DBDropDown
                            className={styles.col2}
                            noteId={this.props.noteId}
                            entity='PTEVAL'
                            entityKeyColumn='EVNO'
                            entityKeyValue={this.props.evno}
                            field='EVSUBSOCLIVEWITH'
                            masterEntity='PTMASTERLIVESWITH'
                            masterEntityKeyColumn='LWNO'
                            masterEntitySort='LWORDER'
                            masterEntityDisplay='LWNAME'
                        />
                        {this.props.livesWithOther &&
                            <DBTextField
                                noteId={this.props.noteId}
                                entity='PTEVAL'
                                entityKeyColumn='EVNO'
                                entityKeyValue={this.props.evno}
                                field='EVSUBSOCLIVESOTHER'
                                className={styles.col3}
                            />
                        }
                    </div>
                    <div className={styles.row}>
                        <label className={styles.col1}>Living environment:</label>
                        <DBDropDown
                            className={styles.col2}
                            noteId={this.props.noteId}
                            entity='PTEVAL'
                            entityKeyColumn='EVNO'
                            entityKeyValue={this.props.evno}
                            field='EVSUBSOCLIVEENVIRON'
                            masterEntity='PTMASTERLIVEENVIRON'
                            masterEntityKeyColumn='LENO'
                            masterEntitySort='LEORDER'
                            masterEntityDisplay='LENAME'
                        />
                    </div>

                    <div className={styles.row}>
                        <label className={styles.col1_wide}>Patient needs to be able to ascend/descend</label>
                        <DBIntField
                            noteId={this.props.noteId}
                            entity='PTEVAL'
                            entityKeyColumn='EVNO'
                            entityKeyValue={this.props.evno}
                            field='EVSUBSOCSTEPS'
                            className={styles.steps}
                            min={0}
                        />
                        <label className={styles.steps_label}>steps in order to navigate the home.</label>

                    </div>

                    <div className={styles.row}>
                        <label className={styles.col1}>Employment/Work:</label>
                        <DBDropDown
                            className={styles.col2}
                            noteId={this.props.noteId}
                            entity='PTEVAL'
                            entityKeyColumn='EVNO'
                            entityKeyValue={this.props.evno}
                            field='EVSUBSOCEMPLOY'
                            masterEntity='PTMASTEREMPLTYPES'
                            masterEntityKeyColumn='ETNO'
                            masterEntitySort='ETORDER'
                            masterEntityDisplay='ETNAME'
                        />
                    </div>

                </div>
            </PatientCareCenterNoteNavAnchor>
        );
    }

}

function mapDispatchToProps(dispatch) {
    return {
        clearFields: bindActionCreators(noteActions.clearFields, dispatch)
    };
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let evno = parseInt(noteId.split("_")[1]);

    let isPeds = state.entities.admissions[state.entities.notes.PTEVAL[evno].EVEPNO].isPeds;
    let isPedsEnabled = state.entities.masterData.PROPS ? state.entities.masterData.PROPS['SAPPHIRE_PEDS_ENABLED'].PRVALUE === 'true' : false;
    if (!isPedsEnabled) {
        isPeds = isPedsEnabled;
    }


    return {
        noteId: noteId,
        evno: evno,
        livesWithOther: state.entities.notes.PTEVAL[evno].EVSUBSOCLIVEWITH && state.entities.notes.PTEVAL[evno].EVSUBSOCLIVEWITH === 6 ? true : false,
        isPeds,
    };
}

const connectedPatientCareCenterNoteSubjectiveSocial = connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterNoteSubjectiveSocial);
export { connectedPatientCareCenterNoteSubjectiveSocial as PatientCareCenterNoteSubjectiveSocial };

